import { call, put, take, select } from "redux-saga/effects";
import api from "../api/api";
import { isResponseSuccessful } from "../helpers/utility";
import studentsSchema from "../schemas/students";
import documentsSchema from "../schemas/documents";
import { normalize } from "normalizr";

import {
  IMPORT_STUDENTS_REQUEST,
  IMPORT_STUDENTS_SUCCESS,
  IMPORT_STUDENTS_FAIL,
  IMPORT_STUDENTS_ASYNC_START,
  IMPORT_STUDENTS_ASYNC_END
} from "../actions/actions";

import {
  FETCH_STUDENTS_LIST_REQUEST,
  FETCH_STUDENTS_LIST_SUCCESS,
  FETCH_STUDENTS_LIST_FAIL,
  FETCH_STUDENTS_LIST_ASYNC_START,
  FETCH_STUDENTS_LIST_ASYNC_END
} from "../actions/actions";

import {
  UPLOAD_STUDENT_DOCUMENT_REQUEST,
  UPLOAD_STUDENT_DOCUMENT_ASYNC_END,
  UPLOAD_STUDENT_DOCUMENT_ASYNC_START,
  UPLOAD_STUDENT_DOCUMENT_SUCCESS,
  UPLOAD_STUDENT_DOCUMENT_FAIL
} from "../actions/actions.js";

import {
  FETCH_STUDENT_DOCUMENTS_REQUEST,
  FETCH_STUDENT_DOCUMENTS_SUCCESS,
  FETCH_STUDENT_DOCUMENTS_FAIL,
  FETCH_STUDENT_DOCUMENTS_ASYNC_END,
  FETCH_STUDENT_DOCUMENTS_ASYNC_START
} from "../actions/actions.js";

import {
  REMOVE_STUDENT_DOCUMENT_REQUEST,
  REMOVE_STUDENT_DOCUMENT_SUCCESS,
  REMOVE_STUDENT_DOCUMENT_FAIL,
  REMOVE_STUDENT_DOCUMENT_ASYNC_START,
  REMOVE_STUDENT_DOCUMENT_ASYNC_END
} from "../actions/actions";

import {
  FETCH_STUDENT_BADGES_REQUEST,
  FETCH_STUDENT_BADGES_SUCCESS,
  FETCH_STUDENT_BADGES_FAILURE
} from "../actions/actions";

export function* importStudents() {
  while (true) {
    const { formData, reject, resolve } = yield take(IMPORT_STUDENTS_REQUEST);
    yield put({ type: IMPORT_STUDENTS_ASYNC_START });

    try {
      const {
        data: {
          data,
          status,
          errors: { form_errors, general_errors }
        }
      } = yield call(api.importStudents, formData);

      if (isResponseSuccessful(status, form_errors, general_errors)) {
        resolve &&
          resolve({
            students: data.uploaded_students,
            studentsData: data.students_data,
            successful: data.successful
          });

        yield put({
          type: IMPORT_STUDENTS_SUCCESS,
          students: data.uploaded_students,
          successful: data.successful,
          studentsData: data.students_data
        });
      } else {
        yield put({ type: IMPORT_STUDENTS_FAIL });
        reject && reject({ form_errors, general_errors });
      }

      yield put({ type: IMPORT_STUDENTS_ASYNC_END });
    } catch (error) {
      reject({ general_errors: error });
      yield put({ type: IMPORT_STUDENTS_ASYNC_END });
      yield put({ type: IMPORT_STUDENTS_FAIL, error });
    }
  }
}

export function* uploadStudentDocument() {
  while (true) {
    const { formData, reject, resolve } = yield take(
      UPLOAD_STUDENT_DOCUMENT_REQUEST
    );
    yield put({ type: UPLOAD_STUDENT_DOCUMENT_ASYNC_START });

    try {
      const {
        data: {
          data,
          status,
          errors: { form_errors, general_errors }
        }
      } = yield call(api.uploadStudentDocument, formData);

      if (isResponseSuccessful(status, form_errors, general_errors)) {
        resolve && resolve(data.document);
        yield put({
          type: UPLOAD_STUDENT_DOCUMENT_SUCCESS,
          document: data.document
        });
      } else {
        yield put({ type: UPLOAD_STUDENT_DOCUMENT_FAIL });
        reject && reject({ form_errors, general_errors });
      }

      yield put({ type: IMPORT_STUDENTS_ASYNC_END });
    } catch (error) {
      console.log(error);
      yield put({ type: UPLOAD_STUDENT_DOCUMENT_ASYNC_END });
      yield put({ type: UPLOAD_STUDENT_DOCUMENT_FAIL, error });
    }
  }
}

export function* removeStudentDocument() {
  while (true) {
    const { documentId, reject, resolve } = yield take(
      REMOVE_STUDENT_DOCUMENT_REQUEST
    );
    yield put({ type: REMOVE_STUDENT_DOCUMENT_ASYNC_START });
    try {
      const {
        data: {
          status,
          errors: { form_errors, general_errors }
        }
      } = yield call(api.removeStudentDocument, documentId);

      if (isResponseSuccessful(status, form_errors, general_errors)) {
        resolve && resolve(documentId);
        yield put({
          type: REMOVE_STUDENT_DOCUMENT_SUCCESS,
          documentId
        });
      } else {
        yield put({ type: REMOVE_STUDENT_DOCUMENT_FAIL });
        reject && reject({ form_errors, general_errors });
      }

      yield put({ type: REMOVE_STUDENT_DOCUMENT_ASYNC_END });
    } catch (error) {
      console.log(error);
      yield put({ type: REMOVE_STUDENT_DOCUMENT_ASYNC_END });
      yield put({ type: REMOVE_STUDENT_DOCUMENT_FAIL, error });
    }
  }
}

export function* getStudentsList() {
  while (true) {
    const { queryString } = yield take(FETCH_STUDENTS_LIST_REQUEST);
    yield put({ type: FETCH_STUDENTS_LIST_ASYNC_START });

    try {
      const {
        data: {
          data,
          status,
          errors: { form_errors, general_errors }
        }
      } = yield call(api.getStudentsList, queryString);

      if (isResponseSuccessful(status, form_errors, general_errors)) {
        yield put({
          type: FETCH_STUDENTS_LIST_SUCCESS,
          students: normalize(data.students, studentsSchema),
          count: data.count
        });
      } else {
        yield put({ type: FETCH_STUDENTS_LIST_FAIL, error: general_errors });
      }

      yield put({ type: FETCH_STUDENTS_LIST_ASYNC_END });
    } catch (error) {
      console.log(error);
      yield put({ type: FETCH_STUDENTS_LIST_ASYNC_END });
      yield put({ type: FETCH_STUDENTS_LIST_FAIL, error });
    }
  }
}

export function* getStudentsDocuments() {
  while (true) {
    yield take(FETCH_STUDENT_DOCUMENTS_REQUEST);
    yield put({ type: FETCH_STUDENT_DOCUMENTS_ASYNC_START });
    const { userId } = yield select(state => state.auth);

    try {
      const {
        data: {
          data,
          status,
          errors: { form_errors, general_errors }
        }
      } = yield call(api.getStudentDocuments, userId);

      if (isResponseSuccessful(status, form_errors, general_errors)) {
        yield put({
          type: FETCH_STUDENT_DOCUMENTS_SUCCESS,
          documents: normalize(data.documents, documentsSchema)
        });
      } else {
        yield put({
          type: FETCH_STUDENT_DOCUMENTS_FAIL,
          error: general_errors
        });
      }

      yield put({ type: FETCH_STUDENT_DOCUMENTS_ASYNC_END });
    } catch (error) {
      console.log(error);
      yield put({ type: FETCH_STUDENT_DOCUMENTS_ASYNC_END });
      yield put({ type: FETCH_STUDENT_DOCUMENTS_FAIL, error });
    }
  }
}

export function* fetchStudentBadges() {
  while (true) {
    yield take(FETCH_STUDENT_BADGES_REQUEST);

    try {
      const {
        data: {
          data,
          status,
          errors: { form_errors, general_errors }
        }
      } = yield call(api.fetchStudentBadges);

      if (isResponseSuccessful(status, form_errors, general_errors)) {
        yield put({
          type: FETCH_STUDENT_BADGES_SUCCESS,
          badges: data.badges
        });
      } else {
        yield put({
          type: FETCH_STUDENT_BADGES_FAILURE,
          error: general_errors
        });
      }
    } catch (error) {
      console.log(error);
      yield put({ type: FETCH_STUDENT_BADGES_FAILURE, error });
    }
  }
}



// WEBPACK FOOTER //
// ./src/sagas/studentsSaga.js